<template>
  <div>
    <reference-indexes-list
      :referenceIndexes="referenceIndexes"
      @add-reference-index="addReferenceIndex()"
      @delete-reference-index="deleteReferenceIndex($event)"
      @edit-reference-index="editReferenceIndex($event)"
    ></reference-indexes-list>
    <a-drawer
      :title="selectedIndex ? selectedIndex.name : 'Add reference index'"
      width="600"
      placement="right"
      :visible="showEditReferenceIndexDrawer"
      @close="onEditReferenceIndexDrawerClosed()"
    >
      <edit-reference-index
        :index="selectedIndex"
        @reference-index-saved="onReferenceIndexSaved($event)"
        @cancel-button-clicked="onEditReferenceIndexDrawerClosed"
      />
    </a-drawer>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import ReferenceIndexesList from '../components/ReferenceIndexes/ReferenceIndexesList.vue'
import EditReferenceIndex from '../components/ReferenceIndexes/EditReferenceIndex.vue'

export default {
  components: {
    EditReferenceIndex,
    ReferenceIndexesList,
  },
  apollo: {
    referenceIndexes: {
      client: 'kpis',
      query: gql`
        query {
          referenceIndexes {
            id
            name
            ticker
            currency
          }
        }
      `,
    },
  },
  data() {
    return {
      referenceIndexes: [],
      showEditReferenceIndexDrawer: false,
      selectedIndex: null,
    }
  },
  methods: {
    addReferenceIndex() {
      this.selectedIndex = null
      this.showEditReferenceIndexDrawer = true
    },
    async deleteReferenceIndex(indexId) {
      await this.$apollo.mutate({
        mutation: gql`
          mutation($indexId: Uuid!) {
            deleteReferenceIndex(indexId: $indexId) {
              indexId
            }
          }
        `,
        variables: {
          indexId,
        },
      })
      this.$apollo.queries.referenceIndexes.refetch()
    },
    editReferenceIndex(index) {
      this.selectedIndex = index
      this.showEditReferenceIndexDrawer = true
    },
    onEditReferenceIndexDrawerClosed() {
      this.selectedIndex = null
      this.showEditReferenceIndexDrawer = false
    },
    onReferenceIndexSaved() {
      this.$apollo.queries.referenceIndexes.refetch()
      this.showEditReferenceIndexDrawer = false
    },
  },
}
</script>
